import React from 'react'
import Richtext from '@/lib/rt/Richtext'
import LinkedHeading from './LinkedHeading'
import RtLink from '@/lib/rt/RtLink'
import RtBlockquote from '@/lib/rt/RtBlockquote'
import RtImage from '@/lib/rt/RtImage'
import RtImageList from '@/lib/rt/RtImageList'
import RtVideoEmbed from '@/lib/rt/RtVideoEmbed'
import CustomHTML from '@/lib/blocks/CustomHTML'
import * as css from './ArticleContent.module.css'

export default function ArticleContent({ content }) {
	return (
		<Richtext
			className={css.content}
			raw={content}
			components={{
				block: {
					h2: props => <LinkedHeading {...props} tag="h2" />,
					h3: props => <LinkedHeading {...props} tag="h3" />,
					h4: props => <LinkedHeading {...props} tag="h4" />,
				},
				marks: {
					link: RtLink,
				},
				types: {
					rtBlockquote: RtBlockquote,
					rtImage: RtImage,
					rtImageList: RtImageList,
					rtVideoEmbed: RtVideoEmbed,
					customHtml: ({ value }) => <CustomHTML {...value} />,
				},
			}}
		/>
	)
}
